export const cart_Loading_status = 'cart_Loading_status';

export const cart_Get_Success_status = 'cart_Get_Success_status';

export const cart_Error_status = 'cart_Error_status';

export const cart_Add_Success_status = 'cart_Add_Success_status';

export const cart_Delete_Success_status = 'cart_Delete_Success_status';

export const cart_Update_Success_status = 'cart_Update_Success_status';

export const cart_Delete_All_Success_status = 'cart_Delete_All_Success_status';